import { render, staticRenderFns } from "./StudentGrid.vue?vue&type=template&id=33351ce0"
import script from "./StudentGrid.vue?vue&type=script&lang=js"
export * from "./StudentGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports